import { useRouter } from '@tanstack/react-router';

export const PRACTICE_CALL_ORIGINS = ['dashboard', 'getting-started'] as const;

export type PracticeCallOrigin = (typeof PRACTICE_CALL_ORIGINS)[number];

export const PRACTICE_CALL_EXIT_ROUTES = {
	dashboard: '/dashboard',
	'getting-started': '/getting-started',
} as const satisfies Record<PracticeCallOrigin, string>;

export const practiceCallOriginOf = (pathname: string): PracticeCallOrigin =>
	pathname.startsWith(PRACTICE_CALL_EXIT_ROUTES['getting-started']) ? 'getting-started' : 'dashboard';

export const usePracticeCallOrigin = (): PracticeCallOrigin => {
	const router = useRouter({ warn: false });
	return practiceCallOriginOf(router?.state.location.pathname ?? '');
};
